import axiosInstance from "../../utils/config/config";

export const getAllPayments = () => async (dispatch) => {
  try {
    dispatch({
      type: "paymentsRequest",
    });   const { data } = await axiosInstance.get("payments/all-payments");
    
        dispatch({
          type: "paymentsSuccess",
          payload: data.payments,
        });
      } catch (error) {
        dispatch({
          type: "paymentsFailure",
          payload: error.response?.data?.message || error.message,
        });
      }
    };
    